import React, { Component, Fragment } from 'react';
import injectSheet from 'react-jss';

import { Card } from '~/eds/src/components/Card/Card';
import { Icon } from '~/eds/src/components/Icon/Icon';
import { injectIntl } from 'react-intl';

import EcInput from '../../../Shared/EcInput/EcInput';
import EcMultipleSelectValue from '../../../Shared/EcMultipleSelectValue/EcMultipleSelectValue';
import EcMultiSelect from '../../../Shared/EcMultiSelect/EcMultiSelect';
import styles from './PermissionSettings.styles';

class PermissionSettings extends Component {
  constructor(props) {
    super(props);

    this.handleRadioChange = this.handleRadioChange.bind(this);

    this.state = {
      usersNameDropdownList: [],
      usersEmailList: [],
      domainList: [],
      selectedOption: undefined,
      showUserMultiSelect: false,
      editData: {
        whitelistedUsers: [],
        whitelistedEmailList: [],
        whitelistedDomainList: [],
      },
    };
  }

  componentDidMount() {
    const {
      whitelistedUsers,
      whitelistedEmailList,
      whitelistedDomainList,
      userNamesDropdownList,
    } = this.props;

    this.setState({
      whitelistedUsers,
      whitelistedEmailList,
      whitelistedDomainList,
      userNamesDropdownList,
      selectedOption: whitelistedUsers.length > 0 ? 'specific' : 'all',
      editData: {
        whitelistedUsers,
        whitelistedEmailList,
        whitelistedDomainList,
      },
    });
  }

  handleRadioChange(selectedOption) {
    const { handlePermissionChange } = this.props;

    this.setState({ selectedOption });
    handlePermissionChange(
      { ...this.state.editData },
      selectedOption === 'specific',
    );
  }

  renderItem(item, name) {
    const { handlePermissionChange, intl } = this.props;
    const { selectedOption } = this.state;

    const presentValue = this.state.editData[name] || [];
    const options = item
      ? item.map((val) => ({
          label: val.display_value,
          value: val.value,
          key: val.item,
        }))
      : [];

    const mappedPlaceholders = {
      whitelistedUsers: intl.formatMessage({
        id: 'PermissionSettings.whitelistedUsersPlaceholder',
        defaultMessage: 'whitelisted users',
        description:
          'Placeholder for whitelisted users input. Example: name = "Document Name"',
      }),
      whitelistedEmailList: intl.formatMessage({
        id: 'PermissionSettings.whitelistedEmailListPlaceholder',
        defaultMessage: 'whitelisted email list',
        description: 'Placeholder for whitelisted email list input',
      }),
      whitelistedDomainList: intl.formatMessage({
        id: 'PermissionSettings.whitelistedDomainListPlaceholder',
        defaultMessage: 'whitelisted domain list',
        description: 'Placeholder for whitelisted domain list input',
      }),
    };

    const placeholderName = mappedPlaceholders[name];
    const isCreatable = name !== 'whitelistedUsers';
    const isDomainList = name === 'whitelistedDomainList';

    const placeholder = intl.formatMessage(
      {
        id: 'PermissionSettings.selectPlaceholder',
        defaultMessage: 'Type in a {name}...',
        description:
          'Placeholder for input field. Example: name = "whitelisted users"',
      },
      { name: placeholderName },
    );

    const noOptionsMessage = intl.formatMessage(
      {
        id: 'PermissionSettings.selectNoOptionsMessage',
        defaultMessage: 'No {name} found',
        description:
          'Message shown when no options are available. Example: name = "Document Name"',
      },
      { name: placeholderName },
    );

    return (
      <div>
        <EcMultiSelect
          value={presentValue}
          options={options}
          onChange={(newItems) => {
            const newState = {};
            newState[name] = isDomainList
              ? newItems.map((item) => ({
                  label: item.label.replace('@', ''),
                  value: item.value.replace('@', ''),
                }))
              : newItems;
            this.setState({
              editData: { ...this.state.editData, ...newState },
            });
            handlePermissionChange(
              { ...this.state.editData, ...newState },
              selectedOption === 'specific',
            );
          }}
          width="30%"
          placeholder={placeholder}
          noOptionsMessage={noOptionsMessage}
          isCreatable={isCreatable}
        />
        {this.renderItemValues(name)}
      </div>
    );
  }

  renderItemValues(name) {
    const { classes, handlePermissionChange, intl } = this.props;
    const { selectedOption } = this.state;
    let presentValues = this.state.editData;
    presentValues = presentValues[name];

    return (
      <div className={classes.multipleValuesContainer}>
        <Icon icon="arrow-forward" />
        <div className={classes.multipleValues}>
          {presentValues.length ? (
            presentValues.map((value) => (
              <EcMultipleSelectValue
                label={value.label}
                key={value.value}
                closeHandler={() => {
                  const newState = {};
                  const newMultiState = [...this.state.editData[name]];
                  newState[name] = newMultiState.filter(
                    (multiValue) => multiValue.value !== value.value,
                  );
                  this.setState({
                    editData: { ...this.state.editData, ...newState },
                  });
                  handlePermissionChange(
                    { ...this.state.editData, ...newState },
                    selectedOption === 'specific',
                  );
                }}
              />
            ))
          ) : (
            <span className={classes.multipleValuesEmpty}>
              {intl.formatMessage({
                id: 'PermissionSettings.noValuesSelected',
                defaultMessage: 'No values selected...',
                description: 'Message shown when no values are selected',
              })}
            </span>
          )}
        </div>
      </div>
    );
  }

  renderMultiSelect(item, name) {
    const { classes } = this.props;

    const multiSelectMenu = this.renderItem(item, name);
    return <div className={classes.overviewInformation}>{multiSelectMenu}</div>;
  }

  render() {
    const { classes, intl } = this.props;
    const {
      selectedOption,
      usersEmailList,
      userNamesDropdownList,
      domainList,
      whitelistedEmailList,
    } = this.state;

    if (!whitelistedEmailList) {
      return null;
    }
    return (
      <Card
        header={{
          title: intl.formatMessage({
            id: 'PermissionSettings.permissionsAndWhitelistingTitle',
            defaultMessage: 'Permissions and Whitelisting',
            description: 'Title for permissions and whitelisting section',
          }),
        }}
        mode="bordered"
      >
        <Fragment>
          <div className={classes.headerUsers}>
            {intl.formatMessage({
              id: 'PermissionSettings.whitelistedUsersHeader',
              defaultMessage: 'WHITELISTED USERS',
              description: 'Header for whitelisted users section',
            })}
          </div>
          <div className={classes.allEmailDocChoice}>
            <EcInput
              type="radio"
              input={{
                value: 'all',
                onChange: (e) => {
                  this.handleRadioChange(e.target.value);
                },
                checked: selectedOption === 'all',
              }}
              width="25px"
              height="17px"
            />
            {intl.formatMessage({
              id: 'PermissionSettings.allUsersEmailDocChoice',
              defaultMessage:
                'Allow all organization users to email documents to Evisort',
              description: 'Option for allowing all users to email documents',
            })}
          </div>
          <div className={classes.selectEmailDocChoice}>
            <EcInput
              type="radio"
              input={{
                value: 'specific',
                onChange: (e) => {
                  this.handleRadioChange(e.target.value);
                },
                checked: selectedOption === 'specific',
              }}
              width="25px"
              height="17px"
            />
            {intl.formatMessage({
              id: 'PermissionSettings.allowSpecificUsersEmailDocChoice',
              defaultMessage:
                'Allow only specific organization users to email documents to Evisort',
              description:
                'Option for allowing specific users to email documents',
            })}
          </div>
          {selectedOption === 'specific'
            ? this.renderMultiSelect(userNamesDropdownList, 'whitelistedUsers')
            : null}

          <div className={classes.headerEmails}>
            {intl.formatMessage({
              id: 'PermissionSettings.whitelistedEmailsHeader',
              defaultMessage: 'WHITELISTED EMAILS',
              description: 'Header for whitelisted emails section',
            })}
          </div>
          {this.renderMultiSelect(usersEmailList, 'whitelistedEmailList')}

          <div className={classes.domainsContainer}>
            <div className={classes.headerEmails}>
              {intl.formatMessage({
                id: 'PermissionSettings.whitelistedDomainsHeader',
                defaultMessage: 'WHITELISTED DOMAINS',
                description: 'Header for whitelisted domains section',
              })}
            </div>
            <div className={classes.domainInfo}>
              {intl.formatMessage({
                id: 'PermissionSettings.whitelistedDomainsInfo',
                defaultMessage:
                  'Any email address from these domains will be able to email documents to Evisort.',
                description: 'Info for whitelisted domains section',
              })}
            </div>
            {this.renderMultiSelect(domainList, 'whitelistedDomainList')}
          </div>
        </Fragment>
      </Card>
    );
  }
}

export default injectSheet(styles)(injectIntl(PermissionSettings));
